function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-list"
}, "List Icon-");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28,27V53H52V27Zm-.5-3h25A2.5,2.5,0,0,1,55,26.5v27A2.5,2.5,0,0,1,52.5,56h-25A2.5,2.5,0,0,1,25,53.5v-27A2.5,2.5,0,0,1,27.5,24Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30.5,
  y: 31.5,
  width: 3,
  height: 3,
  rx: 1
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37,34.5H48.5a1.5,1.5,0,0,0,0-3H37a1.5,1.5,0,0,0,0,3Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30.5,
  y: 38.5,
  width: 3,
  height: 3,
  rx: 1
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37,41.5H48.5a1.5,1.5,0,0,0,0-3H37a1.5,1.5,0,0,0,0,3Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30.5,
  y: 45.5,
  width: 3,
  height: 3,
  rx: 1
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37,48.5H48.5a1.5,1.5,0,0,0,0-3H37a1.5,1.5,0,0,0,0,3Z"
});

var SvgIconList = function SvgIconList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-list",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-list"
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-list.a17ca644.svg";
export { ForwardRef as ReactComponent };